import { render } from "./InternalApp.vue?vue&type=template&id=1b448e96&ts=true"
import script from "./InternalApp.vue?vue&type=script&lang=ts"
export * from "./InternalApp.vue?vue&type=script&lang=ts"

import "./InternalApp.vue?vue&type=style&index=0&id=1b448e96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__